// extracted by mini-css-extract-plugin
module.exports = {"dashboardCardContainer":"Dashboard_dashboardCardContainer__2IHvB"};